const routes = [
  {
    path: 'cellwise-quality-dashboard', // cellwise-quality-dashboard
    component: () => import(/* webpackChunkName: "cellwise-quality-dashboard" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'cellwiseQualityDashboard', // cellwiseQualityDashboard
        component: () => import(/* webpackChunkName: "cellwise-quality-dashboard" */ './views/cellwiseQualityDashboard.vue'),
      },
      {
        path: 'preview',
        name: 'preview',
        component: () => import('./views/preview.vue'),
      },
    ],
  },
];

export default routes;
